import { Tooltip } from "react-tooltip";
import Button from "shared/components/Button";
import { ReactComponent as CompareButtonSVG } from "assets/icons/compare.svg";
import { DELAY_SHOW } from "shared/helpers/reactTooltip";
import { useAppDispatch } from "app/hooks";
import { setOpenPanel } from "features/settings/details-slice";

interface CompareButtonProps {}

const CompareButton: React.FC<CompareButtonProps> = () => {
  const dispatch = useAppDispatch();
  return (
    <div data-tooltip-id="KEY_BUTTON_COMPARE">
      <Button
        colour="Theme"
        additionalClassNames={`PrimaryButton SVGButton ${
          false ? "Active" : ""
        } NoBorder`}
        disabledClass="DisabledOpacity"
        // TEMP: Phase 2 - Sphere selector
        disabled
        onClick={() => {
          dispatch(setOpenPanel("sphereSelector"));
        }}
        children={
          <CompareButtonSVG
            height={20}
            width={20}
            role="button"
            aria-label="Compare"
          />
        }
      />
      <Tooltip
        id="KEY_BUTTON_COMPARE"
        place="top"
        className="ToolTip"
        delayShow={DELAY_SHOW}
        children="Compare"
      />
    </div>
  );
};

export default CompareButton;
